import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface IG2ACode {
  id: string;
  code: string;
  validUntilDate?: string | null;
  subscriptionDays: number;
  isActive: boolean;
  t: number;
  timestamp: number;
  createdTimestamp: number;
  updatedTimestamp: number;
  isRedeemed: boolean;
}

export interface IG2AUsers {
  userId: string;
  codeId: string;
  redeemedAt: string;
}

export const adminPromoApi = createApi({
  reducerPath: 'adminPromoApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    getPromoCodes: builder.query<IG2ACode[], void>({
      query: () => ({
        url: '/admin/promocodes',
        method: 'GET',
      }),
    }),
    createPromoCode: builder.mutation<IG2ACode, Partial<IG2ACode>>({
      query: (body) => ({
        url: '/admin/promocodes',
        method: 'POST',
        body,
      }),
    }),
    updatePromoCode: builder.mutation<IG2ACode, { id: string; data: Partial<IG2ACode> }>({
      query: ({ id, data }) => ({
        url: `/admin/promocodes/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deletePromoCode: builder.mutation<void, string>({
      query: (id) => ({
        url: `/admin/promocodes/${id}`,
        method: 'DELETE',
      }),
    }),
    redeemPromoCode: builder.mutation<IG2AUsers, { code: string }>({
      query: (body) => ({
        url: '/promocode/redeem',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetPromoCodesQuery,
  useCreatePromoCodeMutation,
  useUpdatePromoCodeMutation,
  useDeletePromoCodeMutation,
  useRedeemPromoCodeMutation,
} = adminPromoApi;

